import { createStytchB2BClient } from '@stytch/react/b2b';

/**
 * Cliente Stytch B2B para el admin (BFMWEB-4).
 *
 * El SDK persiste el `session_token` y `session_jwt` internamente y
 * los renueva automáticamente. El JWT se expone vía `getSession()` y
 * lo enviamos al backend en `Authorization: Bearer <jwt>`.
 */

const publicToken = import.meta.env.VITE_STYTCH_PUBLIC_TOKEN;
if (!publicToken) {
  throw new Error('VITE_STYTCH_PUBLIC_TOKEN no está definido');
}

export const stytch = createStytchB2BClient(publicToken);

export const ADMIN_ORG_SLUG = import.meta.env.VITE_STYTCH_ADMIN_ORG_SLUG;
if (!ADMIN_ORG_SLUG) {
  throw new Error('VITE_STYTCH_ADMIN_ORG_SLUG no está definido');
}
